import React from 'react';

import { Box, Grid } from '@mui/material';
import { FieldValues } from 'react-hook-form';
import { makeStyles } from 'tss-react/mui';
import _ from 'lodash';

import { useQuery } from 'global-components/tab/OhsTab';
import { OhsFormSettings } from 'global-components/form/services/OhsFormModels';
import { useAppSelector } from 'app/hooks';
import OhsSelectField from 'global-components/form/fields/OhsSelectField';
import OhsUserLocalServices from 'user/OhsUserLocalServices';
import OhsSearchParams from 'global-services/constants/OhsSearchParams';
import { OhsTabKeyTypes } from 'global-components/tab/OhsTabModels';

import { getGlobalFilter } from '../OhsTopFilterSlice';
import { OhsFilterList } from '../OhsFilterModels';
import OhsWorkplaceFilter from '../filterfields/OhsWorkplaceFilter';
import OhsMultipleSelectField from '../../../global-components/form/fields/OhsMultipleSelectField';
import OhsCheckboxFilter from '../filterfields/OhsCheckboxFilter';

const useStyles = makeStyles()(() => ({
  root: {
    flexGrow: 1,
  },
  fieldWrap: {
    margin: '10px 0 10px 0',
  },
  filterContent: {
    width: '100%',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
interface Props {
  ohsFormSettings: OhsFormSettings<FieldValues>;
}

function OhsInjuryMgmtFilters(props: Props) {
  const { classes } = useStyles();
  const filter = useAppSelector(getGlobalFilter) as OhsFilterList;
  const user = OhsUserLocalServices.getLocalOhsUser();
  const userTierNum = user?.tierNum ?? 0;
  const query = useQuery();
  const tabKey = query.get(OhsSearchParams.Tab);

  const categoryLists = user?.configs.injurymgmt?.CATEGORY_LIST ?? [];

  const [subCategoryLists, setSubCategoryLists] = React.useState<string[]>([]);

  React.useEffect(() => {
    const slist = categoryLists.map((a: any) => a.subcategory);
    const getSubCategories = _.sortBy(_.uniqBy([...new Set(slist.flat())], (item) => item));
    setSubCategoryLists(getSubCategories);
  }, []);

  return (
    <Box className={classes.filterContent}>
      {tabKey === OhsTabKeyTypes.Record && (
        <Grid item md={12} xs={12} className={classes.fieldWrap}>
          <OhsSelectField
            title="Sort By"
            id="injuryMgmtModule.record.sort"
            required
            options={filter.injuryMgmtModule.record.tableSortKeyLists.sortColAscDescOptions}
            ohsFormSettings={props.ohsFormSettings}
          />
        </Grid>
      )}
      {tabKey === OhsTabKeyTypes.Template && (
        <>
          <Grid item md={12} xs={12} className={classes.fieldWrap}>
            <OhsSelectField
              title="Sort By"
              id="injuryMgmtModule.template.sort"
              required
              options={filter.injuryMgmtModule.template.tableSortKeyLists.sortColAscDescOptions}
              ohsFormSettings={props.ohsFormSettings}
            />
          </Grid>
          <Grid item md={12} xs={12} className={classes.fieldWrap}>
            <OhsWorkplaceFilter ohsFormSettings={props.ohsFormSettings} />
          </Grid>

          <Grid item md={12} xs={12} className={classes.fieldWrap}>
            <div>
              <OhsMultipleSelectField
                title="Type"
                id="injuryMgmtModule.template.categories"
                required={false}
                options={categoryLists.map((a) => ({
                  name: a.category,
                  value: a.category,
                }))}
                ohsFormSettings={props.ohsFormSettings}
              />
            </div>
          </Grid>
          <Grid item md={12} xs={12} className={classes.fieldWrap}>
            <div>
              <OhsMultipleSelectField
                title="Category"
                id="injuryMgmtModule.template.subcategories"
                required={false}
                options={subCategoryLists.map((category: any) => ({
                  name: category,
                  value: category,
                }))}
                ohsFormSettings={props.ohsFormSettings}
              />
            </div>
          </Grid>
          {(userTierNum === 3 || userTierNum === 4) && (
            <Grid item md={12} xs={12} className={classes.fieldWrap}>
              <OhsCheckboxFilter
                fieldid="injuryMgmtModule.template.allocatedToWorkplace"
                label="Allocated to Workplace"
                ohsFormSettings={props.ohsFormSettings}
              />
            </Grid>
          )}
          {(userTierNum === 3 || userTierNum === 4) && (
            <Grid item md={12} xs={12} className={classes.fieldWrap}>
              <OhsCheckboxFilter
                fieldid="injuryMgmtModule.template.workplaceOwned"
                label="Workplace Owned"
                ohsFormSettings={props.ohsFormSettings}
              />
            </Grid>
          )}
          {userTierNum === 3 && (
            <Grid item md={12} xs={12} className={classes.fieldWrap}>
              <OhsCheckboxFilter
                fieldid="injuryMgmtModule.template.notAllocated"
                label="Not Allocated"
                ohsFormSettings={props.ohsFormSettings}
              />
            </Grid>
          )}
        </>
      )}
    </Box>
  );
}

export default OhsInjuryMgmtFilters;
